/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/forbid-prop-types */
import React, { useState, useMemo, useEffect } from 'react';
import PropTypes from 'prop-types';
import ModalRoot, { Modal, ModalBody, ModalHeader } from '../../../../components/Modal';
import { walletCurrenciesTypes, WalletScreens, actionTypes } from '../../constants';
import SelectWalletDeposit from './SelectWalletDeposit';
import LedgerWalletDeposit from './LedgerWalletDeposit';
import FiatWalletDeposit from './FiatWalletDeposit';
import FiatWalletWithdrawal from './FiatWalletWithdrawal';
import FiatWalletWithdrawVerify from './FiatWalletWithdrawVerify';
import FiatWalletDepositPGW from './FiatWalletDepositPGW';
import FiatWalletWithdrawalDetails from './FiatWalletWithdrawalDetails';
import SelectWalletWithdraw from './SelectWalletWithdraw';
import {
  useLedgerAccountForWallet,
  useLedgerFilteredCurrencies,
} from '../../../../utilities/sharedHooks/ledgerWallets';
import { SETTINGS_SUPPORTED_CURRENCIES_QUERY_KEY } from '../../../../utilities/sharedQueries';
import Receive from './Receive';
import FiatWithdrawalReview from './FiatWithdrawalReview';
import TransactionProcessed from './TransactionProcessed';
import { GenericLoading } from '../../../../components/Placeholders';

const WalletDepositModal = ({
  hide,
  wallet,
  walletsType,
  isDeposit,
  openAddAccount,
  openSendCrypto,
  refreshWallets,
  actionType,
}) => {
  const isFiat = wallet?.wallet_type?.toLowerCase() === walletCurrenciesTypes.FIAT;

  const [currentOptions, setCurrentOptions] = useState({});

  const [currentScreen, setCurrentScreen] = useState('');

  const depositWallet = currentOptions[WalletScreens.LEDGER_DEPOSIT]?.wallet || wallet;
  const ledgerAccount = useLedgerAccountForWallet(depositWallet);

  const { data: ledgerFilteredCurrencies } = useLedgerFilteredCurrencies([
    SETTINGS_SUPPORTED_CURRENCIES_QUERY_KEY,
  ]);

  const isStableCoin = useMemo(() => {
    if (ledgerFilteredCurrencies) {
      return ledgerFilteredCurrencies[wallet?.coin]?.fiat_currency_peg;
    }
    return null;
  }, [ledgerFilteredCurrencies, wallet?.coin]);

  useEffect(() => {
    let initialScreen;
    if (ledgerFilteredCurrencies) {
      if (wallet) {
        if (isFiat && !isStableCoin) {
          if (isDeposit) {
            initialScreen = WalletScreens.FIAT_DEPOSIT;
          } else {
            initialScreen = WalletScreens.FIAT_WITHDRAWAL;
          }
        } else if (
          ledgerFilteredCurrencies &&
          ledgerFilteredCurrencies[wallet?.coin] &&
          ledgerFilteredCurrencies[wallet?.coin]?.secure_funding_enabled
        ) {
          initialScreen = WalletScreens.LEDGER_DEPOSIT;
        } else if (
          ledgerFilteredCurrencies &&
          ledgerFilteredCurrencies[wallet?.coin] &&
          !ledgerFilteredCurrencies[wallet?.coin]?.secure_funding_enabled
        ) {
          initialScreen = WalletScreens.RECEIVE;
        }
      } else if (actionType === actionTypes.WITHDRAW) {
        initialScreen = WalletScreens.WITHDRAW_WALLET_SELECTION;
      } else {
        initialScreen = WalletScreens.DEPOSIT_WALLET_SELECTION;
      }
    } else {
      initialScreen = WalletScreens.LOADER;
    }

    setCurrentOptions({ [initialScreen]: { wallet } });
    setCurrentScreen(initialScreen);
  }, [ledgerFilteredCurrencies]);

  const ledgerDepositOptions = useMemo(
    () => ({ ...currentOptions[WalletScreens.LEDGER_DEPOSIT], ledgerAccount }),
    [currentOptions, ledgerAccount]
  );

  const screens = useMemo(
    () => [
      {
        screen: WalletScreens.DEPOSIT_WALLET_SELECTION,
        component: (
          <SelectWalletDeposit
            onCloseModal={hide}
            openScreen={(screenName, options) => {
              setCurrentOptions({ [screenName]: options });
              setCurrentScreen(screenName);
            }}
            openAddAccount={openAddAccount}
            walletsType={walletsType}
          />
        ),
      },
      {
        screen: WalletScreens.WITHDRAW_WALLET_SELECTION,
        component: (
          <SelectWalletWithdraw
            onCloseModal={hide}
            openScreen={(screenName, options) => {
              setCurrentOptions({ [screenName]: options });
              setCurrentScreen(screenName);
            }}
            openAddAccount={openAddAccount}
            openSendCrypto={openSendCrypto}
            walletsType={walletsType}
          />
        ),
      },
      {
        screen: WalletScreens.LEDGER_DEPOSIT,
        component: (
          <LedgerWalletDeposit
            openScreen={(screenName, options) => {
              setCurrentOptions({ [screenName]: options });
              setCurrentScreen(screenName);
            }}
            options={ledgerDepositOptions}
          />
        ),
      },
      {
        screen: WalletScreens.FIAT_DEPOSIT,
        component: (
          <FiatWalletDeposit
            onCloseModal={hide}
            options={currentOptions[WalletScreens.FIAT_DEPOSIT]}
            refreshWallets={refreshWallets}
          />
        ),
      },
      {
        screen: WalletScreens.RECEIVE_DETAILS,
        component: (
          <FiatWalletDepositPGW
            onCloseModal={hide}
            onPrevClick={() => {
              setCurrentOptions({
                [WalletScreens.LEDGER_DEPOSIT]: currentOptions[WalletScreens.RECEIVE_DETAILS],
              });
              setCurrentScreen(WalletScreens.LEDGER_DEPOSIT);
            }}
            options={currentOptions[WalletScreens.RECEIVE_DETAILS]}
            openScreen={(screenName, options) => {
              setCurrentOptions({ [screenName]: options });
              setCurrentScreen(screenName);
            }}
            refreshWallets={refreshWallets}
          />
        ),
      },
      {
        screen: WalletScreens.FIAT_WITHDRAWAL,
        component: (
          <FiatWalletWithdrawal
            onCloseModal={hide}
            options={currentOptions[WalletScreens.FIAT_WITHDRAWAL]}
            openScreen={(screenName, options) => {
              setCurrentOptions({ [screenName]: options });
              setCurrentScreen(screenName);
            }}
          />
        ),
      },
      {
        screen: WalletScreens.FIAT_WITHDRAWAL_REVIEW,
        component: (
          <FiatWithdrawalReview
            onCloseModal={hide}
            options={currentOptions[WalletScreens.FIAT_WITHDRAWAL_REVIEW]}
            openScreen={(screenName, options) => {
              setCurrentOptions({ [screenName]: options });
              setCurrentScreen(screenName);
            }}
          />
        ),
      },
      {
        screen: WalletScreens.FIAT_WITHDRAWAL_DETAILS,
        component: (
          <FiatWalletWithdrawalDetails
            onCloseModal={hide}
            options={currentOptions[WalletScreens.FIAT_WITHDRAWAL_DETAILS]}
            openScreen={(screenName, options) => {
              setCurrentOptions({ [screenName]: options });
              setCurrentScreen(screenName);
            }}
          />
        ),
      },
      {
        screen: WalletScreens.VERIFY_TRANSACTION,
        component: (
          <FiatWalletWithdrawVerify
            onCloseModal={hide}
            options={currentOptions[WalletScreens.VERIFY_TRANSACTION]}
            openScreen={(screenName, options) => {
              setCurrentOptions({ [screenName]: options });
              setCurrentScreen(screenName);
            }}
          />
        ),
      },
      {
        screen: WalletScreens.RECEIVE,
        component: (
          <Receive
            options={currentOptions[WalletScreens.RECEIVE] || []}
            openScreen={(screenName, options) => {
              setCurrentOptions({ [screenName]: options });
              setCurrentScreen(screenName);
            }}
          />
        ),
      },
      {
        screen: WalletScreens.SEND_CRYPTO,
        component: (
          <Receive
            options={currentOptions[WalletScreens.RECEIVE] || []}
            openScreen={(screenName, options) => {
              setCurrentOptions({ [screenName]: options });
              setCurrentScreen(screenName);
            }}
          />
        ),
      },
      {
        screen: WalletScreens.TRANSACTION_PROCESSED,
        component: (
          <TransactionProcessed options={currentOptions[WalletScreens.TRANSACTION_PROCESSED]} />
        ),
      },
      {
        screen: WalletScreens.LOADER,
        component: (
          <div>
            <GenericLoading isFullScreen={false} customSize="4rem" customSpacing="pt-4 mt-4" />
          </div>
        ),
      },
    ],
    [currentOptions, ledgerDepositOptions, hide, walletsType]
  );

  const SelectedComponent = useMemo(
    () => screens.find((item) => item.screen === currentScreen)?.component || WalletScreens.LOADER,
    [screens, currentScreen]
  );

  return (
    <ModalRoot>
      <Modal>
        <ModalHeader>
          <i
            onClick={hide}
            onKeyDown={hide}
            role="button"
            className="close-btn cursor-pointer icon icon-close-other text-shadow"
            tabIndex={-1}
            aria-label="Close"
          />
        </ModalHeader>
        <ModalBody>{SelectedComponent}</ModalBody>
      </Modal>
    </ModalRoot>
  );
};

WalletDepositModal.propTypes = {
  hide: PropTypes.func,
  wallet: PropTypes.object,
  walletsType: PropTypes.string,
  isDeposit: PropTypes.bool,
  openAddAccount: PropTypes.func,
  openSendCrypto: PropTypes.func,
  refreshWallets: PropTypes.func,
  actionType: PropTypes.string,
};
WalletDepositModal.defaultProps = {
  hide: null,
  wallet: {},
  walletsType: null,
  isDeposit: null,
  openAddAccount: () => {},
  openSendCrypto: () => {},
  refreshWallets: () => {},
  actionType: null,
};

export default WalletDepositModal;
